export const CALLBACK_CONFIRMATION_PATH = "/callback-confirmation/";

export const isOutsideCallbackBusinessHours = (date = new Date()) => {
  const hour = Number(
    new Intl.DateTimeFormat("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      hourCycle: "h23",
    }).format(date),
  );

  return hour >= 20 || hour < 10;
};

export const getCallbackConfirmationUrl = (redirectUrl: string) => {
  const outsideBusinessHours = isOutsideCallbackBusinessHours();
  const params = new URLSearchParams({
    redirectUrl,
    ...(outsideBusinessHours ? { outsideBusinessHours: "true" } : {}),
  });

  return `${CALLBACK_CONFIRMATION_PATH}?${params.toString()}`;
};

export const buildCallbackMessage = ({
  brandName,
  modelName,
  variantName,
  cityName,
  intent,
}: {
  brandName?: string;
  modelName?: string;
  variantName?: string;
  cityName: string;
  intent?: string;
}) => {
  const vehicle = [brandName, modelName, variantName].filter(Boolean).join(" ");
  const selectedIntent = intent ? `; selected_intent: ${intent}` : "";

  return `Request callback for ${vehicle} in ${cityName}${selectedIntent}`;
};
